import $ from 'jquery'

import { showLoading, hideLoading } from './loading'
import getMessage                   from '../messages/getMessage'

let $panel,
    $content,
    $wrap,
    first_q

/**
 * Render a bot message to the panel
 *
 * @param string
 * @return void
 */
export const render = message => {

  if ( !message.user || !message.text )
    return

  let $msg_el     = $( `<div class="msg ${ message.user !== 'user' ? 'not_deployed' : '' } ${ message.user }"><div>${ message.text }</div></div>` ),
      options_txt = '',
      $options_el,
      $ask_again_el

  switch ( message.type ) {

    case 'Multiple Choice':
      if ( message.options.length ) {
        message.options.sort( orderSort )

        $msg_el.attr( 'msg_id', message.id )

        options_txt = `<div class="options not_deployed ${ message.user }">`
        message.options.forEach( option => {
          if ( option.id && option.linkText )
            options_txt += `<div msg_id="${ option.id }">${ option.linkText }</div>`
        } )
        options_txt += '</div>'

        $options_el = $( options_txt )
      }
      break

    case 'Single':
      if ( message.options.length )
        setTimeout( () => getMessage( message.options[ 0 ].id ), 500 )
      else
        $ask_again_el = $( `<div class="ask-again not_deployed" msg_id="${ first_q }">Ask another question</a>` )
      break

  }

  setTimeout( () => {
    $msg_el.removeClass( 'not_deployed' )
    if ( $options_el )
      $options_el.removeClass( 'not_deployed' )
    if ( $ask_again_el )
      setTimeout( () => $ask_again_el.removeClass( 'not_deployed' ), 500 )
  }, 50 )

  $wrap.append( $msg_el, $options_el, $ask_again_el )

  hideLoading()
  scrollPos()
}

/*
 * Sort items by specified order number
 */
const orderSort = ( a, b ) => parseFloat( a.order ) - parseFloat( b.order )

/**
 * Scroll messages to the bottom
 */
const scrollPos = () => $content.scrollTop( $content[ 0 ].scrollHeight )

const init = () => {
  $panel   = $( '.your-chat__panel' )  .first(),
  $content = $panel                    .find( '.chat-content' ),
  $wrap    = $content                  .find( '.wrap' ),
  first_q  = $panel                    .attr( 'init_q' )
}

export default () => init()
